import {CONFIG} from "../../config";
import axios from "axios";

async function GetUserNotificationsCountQuery(){
    const location = CONFIG.API_URL + "user_notification/get_count";
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };
    
    try {
        return await axios.get(location, settings);
    } catch (e) {
        return e;
    }
}

export default GetUserNotificationsCountQuery;